import { c as _c } from "react-compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
export default function usePageIsVisible() {
  "use memo";

  const $ = _c(3);
  const [pageIsVisible, setPageIsVisible] = useState(document.visibilityState === "visible");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setPageIsVisible(document.visibilityState === "visible");
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleVisibilityChange = t0;
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      window.addEventListener("visibilitychange", handleVisibilityChange);
      return () => {
        window.removeEventListener("visibilitychange", handleVisibilityChange);
      };
    };
    t2 = [handleVisibilityChange];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return pageIsVisible;
}